import { getUrnFromContent, MEDIA_TYPE } from '@rosetta/gaia-media';
import { localizationModel } from '../content-localization/localization-model';

export var getCourseTopicName = function getCourseTopicName(course, languages) {
  if (course.topics && course.topics[0]) {
    return localizationModel.getLocalizedContentText(course.topics[0].localizations, languages);
  }
};

export var isAssigned = function isAssigned(assignedCourses, id) {
  return !!assignedCourses && assignedCourses.find(function (assignedCourse) {
    return assignedCourse.courseId === id;
  });
};

export var getSequenceById = function getSequenceById(course, sequenceId) {
  if (!course || !course.sequences || !sequenceId) {
    return null;
  }
  return course.sequences.find(function (s) {
    return s.sequenceId === sequenceId || s.id === sequenceId;
  });
};

export var getImages = function getImages(object) {
  if (!object || !object.images) {
    return null;
  }
  // TODO:  errorHandler was logger.sendToAirbrake - reinstate somehow?
  var mainImages = getUrnFromContent({
    mediaInfoOrArray: object.images,
    mediaDescriptor: 'main',
    mediaType: MEDIA_TYPE.IMAGE,
    errorHandler: console.error
  });
  return mainImages && mainImages[0];
};

export var getCourseImages = function getCourseImages(course) {
  var courseImages = getImages(course);
  if (courseImages) {
    return courseImages;
  }
  var topic = course.topics[0];
  var topicImages = getImages(topic);
  if (topicImages) {
    return topicImages;
  }
  return [];
};

export var courseModel = {
  getCourseTopicName: getCourseTopicName,
  isAssigned: isAssigned,
  getSequenceById: getSequenceById,
  getImages: getImages,
  getCourseImages: getCourseImages
};